module.exports = __webpack_public_path__ + "img/artic2_sample.43547aca.png";